<template>
    <div id="index" :class="['index', `${scene}`]">
        <div class="content">
            <router-view />
        </div>
        <van-overlay :show="loadingShow" />
        <div class="loading" v-if="loadingShow">
            <van-loading type="spinner" color="#1989fa" class="flex-center" />
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Loading, Overlay } from 'vant';
import { mapMutations, mapState } from 'vuex';
import { getBrowser, jsonParser } from '@/lib/utils';
import { Platform } from '@/enums';

Vue.use(Loading);
Vue.use(Overlay);

export default {
    computed: {
        ...mapState({
            platform: state => state.platform || jsonParser(sessionStorage.getItem('platform')),
        }),

        loadingShow() {
            return this.$store.state.loading;
        },
        scene() {
            return Platform[this.platform] || '';
        },
    },
    created() {
        this.webModeFunc();
        this.setBrowser(getBrowser());
        window.onlanguagechange = () => {
            window.location.reload();
        };
    },
    beforeMount() {
        window.addEventListener('resize', this.webModeFunc);
    },
    beforeDestroy() {
        window.onlanguagechange = null;
        window.removeEventListener('resize', this.webModeFunc);
    },
    methods: {
        ...mapMutations(['setBrowser']),

        webModeFunc() {
            // 移动端全屏适配（移除 'app-pc' 类名）
            const fullScreenPlatforms = [
                Platform.WebView,
                Platform.Android,
                Platform.WebViewTransfer,
            ];
            if (fullScreenPlatforms.includes(this.platform)) {
                document.documentElement.classList.add('app-client');
                document.documentElement.classList.remove('app-pc');
                return;
            }

            // webMode: PC 端样式展示，mobile: 移动端样式展示
            if (window.matchMedia('(min-width: 500px)').matches) {
                document.documentElement.classList.add('app-pc');
                document.documentElement.classList.remove('app-client');
            }
        },
    },
};
</script>
<style scoped lang="scss">
.index,
.content {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}

.loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1000;
}
</style>
